import API_CONFIG from '../../../config/api';

const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

const resolveMediaUrl = (value) => {
    if (!value || typeof value !== 'string') {
        return '';
    }

    if (ABSOLUTE_URL_PATTERN.test(value) || value.startsWith('blob:') || value.startsWith('data:')) {
        return value;
    }

    const baseUrl = String(API_CONFIG.BASE_URL || '').replace(/\/$/, '');
    const path = value.startsWith('/') ? value : `/${value}`;
    return `${baseUrl}${path}`;
};

export default resolveMediaUrl;
